/**
 * @description 卡片类型枚举
 */
export default  {
    articleNoPic: 11,
    articleOnePic: 10,
    list: 1,
    atlas: 20,
    signup: [30, 32],
    contact: 31,
    commonCon: 33,
    artLeftImg: [34, 51,63],
    artPoster: [35, 36, 64, 65],
    qrCode: [47],
    vote: [66], // 投票
    shopCard: [31, 30, 32, 33, 34, 35, 36, 47, 51, 63, 64, 65, 66],
}